import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import "./assets/base.scss";
import { Provider } from "react-redux";
import Main from "./DemoPages/Main";
import configureStore from "./config/configureStore";
const store = configureStore();
const rootElement = document.getElementById("root");
const renderApp = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Component />
      </HashRouter>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./DemoPages/Main", () => {
    const NextApp = require("./DemoPages/Main").default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
